/**
 * @todo Build and error handler. Use appContext.addAlert() (?) Must adjust so it can useContext
 *
 * @param error the JavaScript error
 */
export const errorHandler = (error: Error) => {
    console.log(error);
  };
  